import { render, staticRenderFns } from "./Discipline_talk.vue?vue&type=template&id=14d92b60&scoped=true"
import script from "./Discipline_talk.vue?vue&type=script&setup=true&lang=js"
export * from "./Discipline_talk.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Discipline_talk.vue?vue&type=style&index=0&id=14d92b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d92b60",
  null
  
)

export default component.exports